import Inputmask from 'inputmask';

window.mobileCheck = function () {
    var check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

// region Radio and Checkbox Fix
$('.radio-label').keypress(function (e) {
    if (e.keyCode === 0 || e.keyCode === 32) {
        $(this).find('input').prop('checked', true);
    }
});

$('.checkbox-label').keypress(function (e) {
    if (e.keyCode === 0 || e.keyCode === 32) {
        var $ele = $(this).find('input');
        $ele.prop('checked', !$ele.is(':checked'));
    }
});
// endregion

// region Side Menu Toggle
$(document).on('click', '.js-toggle-side-menu', function (event) {
    event.preventDefault();

    var $sideMenu = $('.js-off-canvas-wrap');
    $sideMenu.toggleClass('move-left');

    if ($sideMenu.hasClass('move-left')) {
        $('.mobile-link').attr('tabindex', '-1').attr('aria-hidden', true);
    } else {
        // $('.js-toggle-side-menu').focus();
        $('.mobile-link').attr('tabindex', '0').attr('aria-hidden', false);
    }
});
// endregion

// region Modal Window Panel Collapse
$('.collapse').on('hide.bs.collapse', function () {
    $('.accordion-button-icon').removeClass('minus').addClass('plus');
}).on('show.bs.collapse', function () {
    $('.accordion-button-icon').removeClass('plus').addClass('minus');
});

$('.modal').on('show.bs.modal', function () {
    $('.modal .modal-body').css('overflow-y', 'auto');
    $('.modal .modal-body').css('max-height', $(window).height() * 0.7);
});
// endregion

// region Range Slider
var sliderControl = $('.js-slider-control');
if (sliderControl.length > 0) {
    sliderControl
        .rangeslider({
            polyfill: false,
            onInit: function () {
                $('.rangeslider__handle', this.$range)[0].textContent = '£' + this.value;
            }
        })
        .on('input', function () {
            $('.rangeslider__handle', this.$range)[0].textContent = '£' + this.value;
        });
}
// endregion

// region Cookie Banner
$(document).ready(function () {
    var $cookieBannerContainer = $('.cookie-banner-container');

    if ($cookieBannerContainer.attr('data-can-open') === 'true') {
        $cookieBannerContainer.addClass('open');
    }
});

$(document).on('click', '.js-toggle-cookie-banner', function (event) {
    $('.cookie-banner-container').toggleClass('open');
});

$(document).on('click', '.js-cookie-close', function (event) {
    event.preventDefault();

    $.ajax({
        method: 'get',
        url: $(this).attr('data-url'),
        dataType: 'json',
        data: {analytics: $('#analytics').is(':checked')},
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
        success: function (response) {
            $('.cookie-banner-container').removeClass('open').addClass('hidden');
        },
    });
});
// endregion

$(function () {
    // region Scroll to Errors
    var $elementError = $('.form-group.has-error:first');
    if ($elementError.length > 0) {
        // scroll to error
        $('html, body').animate({
            scrollTop: $elementError.offset().top
        }, 100);
    }
    // endregion

    // region Scroll to message if on mobile
    if(window.mobileCheck()) {
        var $elementMessage = $('.alert');
        if ($elementMessage.length > 0) {
            $('html, body').animate({
                scrollTop: $elementMessage.offset().top
            }, 100);
        }
    }
    // endregion

    // region Date Picker
    let $datePickers = $('.date_picker');
    if ($datePickers.length > 0) {
        $datePickers.datepicker({
            format: "dd-mm-yyyy",
            todayHighlight: true,
            orientation: "bottom auto",
            autoclose: true
        });
    }
    // endregion

    Inputmask().mask($("input[data-inputmask]"));
});

// region Password Strength Indicator
var $strengthIndicator = $('.js-strength-indicator');
if ($strengthIndicator.length > 0) {
    $(document).on('keyup', 'input[name="password"]', function () {
        var value = $(this).val(),
            total = 0;

        $strengthIndicator.removeClass(function (index, css) {
            return (css.match(/(^|\s)__\S+/g) || []).join(' ');
        });

        if (value.length >= 6) {
            total++;
        }

        if (/[A-Z]/.test(value)) {
            total++;
        }

        if (/[0-9]/.test(value)) {
            total++;
        }

        if (/^[a-zA-Z0-9- ]*$/.test(value) === false) {
            total++;
        }

        if (value.length < 6) {
            total = 0;
            $strengthIndicator.addClass('_short');
        } else {
            $strengthIndicator.removeClass('_short');
        }

        switch (total) {
            case 1:
                $strengthIndicator.addClass('__weak');
                break;
            case 2:
                $strengthIndicator.addClass('__bad');
                break;
            case 3:
                $strengthIndicator.addClass('__good');
                break;
            case 4:
                $strengthIndicator.addClass('__strong');
                break;
        }
    });
}
// endregion

// region Message Scroll
var $chatArea = $('.js-messages');

$(document).ready(function () {
    $chatArea.scrollTop($chatArea.prop('scrollHeight'));
});
// endregion

// region Account JS
$('.container.raf').on('click', '.js-social-whatsapp', function (event) {
    event.preventDefault();

    $('.js-social-form').attr('data-href', ($(this).attr('href'))).removeClass('hide');
}).on('submit', '.js-social-form', function (event) {
    event.preventDefault();

    var url = $(this).attr('data-href');
    url = url.replace('[FRIENDS NUMBER]', $(this).find('input').val());

    window.open(url, '_blank');
});
// endregion

// region Accordion Fix
$(document).on('click', '.simple-accordion .collapse-label', function(event) {
    event.stopPropagation();
    var $this = $(this);
    var href;

    var parent = $this.data('parent');
    var actives = parent && $(parent).find('.collapse.in');

    if (actives && actives.length) {
        actives.collapse('hide');
    }

    var target = $this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, ''); //strip for ie7

    $(target).collapse('toggle');
});
// endregion

import cssVars from 'css-vars-ponyfill';
cssVars({
    rootElement: document,
    onlyLegacy: true,
    include: '[data-include]',
    preserveStatic: true,
});


// region Modal trap keyboard focus function
function trapKeyboardFocus(selector_id) {
    const modal = document.querySelector(selector_id); // select the modal by it's id
    if (!modal) {
        console.error('Modal does not exist: ' + selector_id);
        return;
    }

    // add all the elements inside modal which you want to make focusable
    const focusableElements =
        '[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

    const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
    const focusableContent = modal.querySelectorAll(focusableElements);
    const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

    document.addEventListener('keydown', function (e) {
        let isTabPressed = e.key === 'Tab';

        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
                console.log('shift');
                lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        } else { // if tab key is pressed
            if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                console.log('tab');
                firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
            }
        }
    });
}

// endregion
